import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { apolloClient } from "../../constants/apolloClient";
import { LibraryV1GetMultipleFeatureFlagsDocument } from "./graphql/GetMultipleFeatureFlags.v5.generated";
/**
 * Fetch multiple V5 feature flags in a single GraphQL request.
 * Returns one TFetchFlagReturnType per requested flag key.
 */
export function fetchV5FeatureFlagsBatch(_x) {
  return _fetchV5FeatureFlagsBatch.apply(this, arguments);
}
function _fetchV5FeatureFlagsBatch() {
  _fetchV5FeatureFlagsBatch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref) {
    var flagKeys, organizationId, _data$features_flags, _yield$apolloClient$q, data, error, result, _result$errors$join, _result$errors, errorMessage, flagMap, _iterator, _step, ff, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          flagKeys = _ref.flagKeys, organizationId = _ref.organizationId;
          _context.p = 1;
          _context.n = 2;
          return apolloClient.query({
            query: LibraryV1GetMultipleFeatureFlagsDocument,
            fetchPolicy: 'cache-first',
            variables: {
              input: {
                name_keys: flagKeys,
                organization_id: String(organizationId)
              }
            },
            context: {
              clientName: 'v5'
            }
          });
        case 2:
          _yield$apolloClient$q = _context.v;
          data = _yield$apolloClient$q.data;
          error = _yield$apolloClient$q.error;
          if (!error) {
            _context.n = 3;
            break;
          }
          return _context.a(2, flagKeys.map(function (flagKey) {
            return {
              flagKey: flagKey,
              flagValue: false,
              apiVersion: 'V5',
              error: error
            };
          }));
        case 3:
          result = data === null || data === void 0 ? void 0 : (_data$features_flags = data.features_flags) === null || _data$features_flags === void 0 ? void 0 : _data$features_flags.get_feature_flags; // Handle error union types
          if (!((result === null || result === void 0 ? void 0 : result.__typename) === 'QueryValidationError' || (result === null || result === void 0 ? void 0 : result.__typename) === 'QueryInternalError')) {
            _context.n = 4;
            break;
          }
          errorMessage = (_result$errors$join = (_result$errors = result.errors) === null || _result$errors === void 0 ? void 0 : _result$errors.join(', ')) !== null && _result$errors$join !== void 0 ? _result$errors$join : 'Unknown error';
          return _context.a(2, flagKeys.map(function (flagKey) {
            return {
              flagKey: flagKey,
              flagValue: false,
              apiVersion: 'V5',
              error: new Error(errorMessage)
            };
          }));
        case 4:
          // Success — build a map for fast lookup
          flagMap = new Map();
          if ((result === null || result === void 0 ? void 0 : result.__typename) === 'GetFeatureFlagsPayload') {
            _iterator = _createForOfIteratorHelper(result.feature_flags);
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                ff = _step.value;
                flagMap.set(ff.name_key, Boolean(ff.value));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          // Return one result per requested key (flags not found default to false)
          return _context.a(2, flagKeys.map(function (flagKey) {
            var _flagMap$get;
            return {
              flagKey: flagKey,
              flagValue: (_flagMap$get = flagMap.get(flagKey)) !== null && _flagMap$get !== void 0 ? _flagMap$get : false,
              apiVersion: 'V5'
            };
          }));
        case 5:
          _context.p = 5;
          _t = _context.v;
          console.error('Error fetching feature flags batch', _t);
          return _context.a(2, flagKeys.map(function (flagKey) {
            return {
              flagKey: flagKey,
              flagValue: false,
              apiVersion: 'V5',
              error: _t
            };
          }));
      }
    }, _callee, null, [[1, 5]]);
  }));
  return _fetchV5FeatureFlagsBatch.apply(this, arguments);
}